import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../../../services/local-storage';
import { LoaderService } from '../../../services/Spinner.service';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupSegmentComponent } from '../../shared/components/popupAdmin/popup-segment.component';
import { Router } from '@angular/router';
import { Data } from "./data";

@Component({
    selector: 'app-couponcode',
    templateUrl: './targetaudcouponcode.component.html',
  providers: [ SharedService,PopupSegmentComponent]
 
})
export class TargetAudienceCouponCodeComponent implements OnInit {

data=[];
i=1;
searchCompanyText = '';
page : number =1;
itemsTotalAdv : number =0;
enable = [];
objLoaderStatus: boolean = false;
blockedFlag : boolean = false;
message = '';
disabledCheckValue =[];
errormessage = '';
charFlag :boolean = false;
userId : number;
searchmessage = "";
companies =[];
coupon =[];
companyFlag : boolean;
user = [];
companiesSelected =[];
companySelected = {"id":'',"name":''};
branchData = [];
branches =[];
radioselected : any;
    constructor(private localstorage: LocalStorage,
     private loaderService: LoaderService,
    private formBuilder: FormBuilder,
    private shareService: SharedService,
    private PopupSegment: PopupSegmentComponent, 
    private dialogService:DialogService,
    private router: Router,
    private dataCompany: Data,
) {

    
    }

    ngOnInit() {
      var x= document.getElementById('id1');
       x.classList.toggle("submenuActive"); 
       this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });

     
this.localstorage.setStorage("country",'');
 if(this.dataCompany.storage && this.dataCompany.storage.coupon){
this.coupon = this.dataCompany.storage.coupon;
 }
  if(this.dataCompany.storage && this.dataCompany.storage.companies){
this.companies= this.dataCompany.storage.companies;
 }

  if(this.dataCompany.storage && this.dataCompany.storage.branches){
this.branches = this.dataCompany.storage.branches;
 }

 if(this.dataCompany.storage && this.dataCompany.storage.companySelected){
this.companiesSelected = this.dataCompany.storage.companySelected;
 }


  if(this.dataCompany.storage && this.dataCompany.storage.flag){
this.companyFlag= this.dataCompany.storage.flag;
 }

  if(this.dataCompany.storage && this.dataCompany.storage.selected){
this.user = this.dataCompany.storage.selected;
 }

  if(this.dataCompany.storage && this.dataCompany.storage.radioselected == false){
this.radioselected = this.dataCompany.storage.radioselected;
 }
localStorage.setItem("user",JSON.stringify(this.user));

       var i=0;
       var j=0;
         var token = this.localstorage.getStorage("token");
         this.loaderService.displayLoader(true);
  this.shareService.CallDatawithToken("master/getAllCompanies", null, token).subscribe((result) => {
if(result.data){
    this.data = result.data;
 this.dataModulation();
           this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
  this.loaderService.displayLoader(false);
}
     });
    }

nextCompany(event){
   this.itemsTotalAdv =0;
    var j=0;
    var i=0;
    this.page = event;
    var token = this.localstorage.getStorage("token");
    this.errormessage ="";
    this.searchmessage = "";
    this.searchCompanyText = this.searchCompanyText.trim();
    if(this.searchCompanyText =='' || this.searchCompanyText == undefined){
          this.loaderService.displayLoader(true);

  this.shareService.CallDatawithToken("master/getAllCompanies?currentPage="+event, null, token).subscribe((result) => {
    if(result.data){
      if(result.data.length>0){
    this.data = result.data;
    this.dataModulation();
        this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
      }
       else{
        this.searchmessage = "No records found";
      }
    this.loaderService.displayLoader(false);

}
  
         });
    } 
    else{
       if(this.searchCompanyText.length<2){
this.errormessage = "Please enter minimum 2 characters";
this.charFlag = true;
       }
       else{
                   this.loaderService.displayLoader(true);
      this.shareService.CallDatawithToken("master/searchCompanyByName?currentPage="+event+"&currentSize=25&q="+this.searchCompanyText, null, token).subscribe((result) => {
    if(result.data){
      if(result.data.length>0){
    this.data = result.data;

this.dataModulation();
    this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
    }
     else{
        this.searchmessage = "No records found";
      }
              this.loaderService.displayLoader(false);

    }
         });
    }
    }
    return event; 
    
}

dataModulation(){
  var i=0;
  var j=0;
    for(i=0;i<this.data.length;i++){
  for(j=0;j<this.companies.length;j++){
if(this.data[i].id == this.companies[j]){
  this.disabledCheckValue[this.data[i].id ] = true;
}
  }
    }
}

allCompany(){
    this.page = 1;
this.searchCompanyText = '';
    var token = this.localstorage.getStorage("token");
  this.searchCompanyText = '';
        this.itemsTotalAdv = 0;
 this.errormessage ="";
this.searchmessage ="";
   this.loaderService.displayLoader(true);
  this.shareService.CallDatawithToken("master/getAllCompanies", null, token).subscribe((result) => {
   if(result.data){
    this.data = result.data;
    this.dataModulation();
           this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
  this.loaderService.displayLoader(false);
}
         });
}
   searchCompany(searchCompanyText){
     this.itemsTotalAdv =0;
       this.data =[];
              this.page =1;

      var token = this.localstorage.getStorage("token");
        //this.id = id;
         this.errormessage ="";
         this.searchmessage ="";
this.searchCompanyText = this.searchCompanyText.trim();
if(searchCompanyText.length == 0){
this.loaderService.displayLoader(true);

  this.shareService.CallDatawithToken("master/getAllCompanies", null, token).subscribe((result) => {
    console.log(result.data);
    if(result.data){
    this.data = result.data;
    this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
     this.loaderService.displayLoader(false);
  this.dataModulation();
    }
         });
}
      else if(searchCompanyText.length<2){
this.errormessage = "Please enter minimum 2 characters";
this.charFlag = true;
       }
       else{
         this.loaderService.displayLoader(true);
      
 this.shareService.CallDatawithToken("master/searchCompanyByName?currentPage=1&currentSize=25&q="+searchCompanyText, null, token).subscribe((result) => {

    if(result.data){
       if(result.data.length>0){
    this.data = result.data;
    this.dataModulation();
    this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
    }
     else{
        this.searchmessage = "No records found";
      }
        this.loaderService.displayLoader(false);
  }
  
         });
   }
       
}

 
changeSelect(id,name,e){
  var i=0;
  var j=0
  for(i=0;i<this.data.length;i++){
if(this.data[i].id == id){
  this.disabledCheckValue[id] = e.target.checked;
    var token = this.localstorage.getStorage("token");
      //   this.loaderService.displayLoader(true);
//   this.shareService.CallDatawithToken("admin/searchAdvertisersByCompanyName?q="+name, null, token).subscribe((result) => {
// if(result.data){
//   this.branchData = result.data;
//   this.loaderService.displayLoader(false);
// }
//     });
  if(e.target.checked == true){


  this.companies.push(this.data[i].id);
//    setTimeout(function () {
//  for(j=0;j<this.branchData.length;j++){
//   this.branches.push(this.branchData[j].userId);
// }
//   }.bind(this), 600);
}
else{
  var index= this.companies.indexOf(this.data[i].id);
  this.companies.splice(index,1);
//  setTimeout(function () {
//    for(j=0;j<this.branchData.length;j++){
//        var indexBranch= this.branches.indexOf(this.branchData[j].userId);
//            this.branches.splice(indexBranch,1);
//   }
//     }.bind(this), 600);
}



}
  }

  return e;
}
  
selectBranches(user){
 
 this.dataCompany.storage = {
"user":user,
 "companies": this.companies,
    "coupon": this.coupon,
  "branches": this.branches,
    "companiesSelected":this.companiesSelected,
  "radioselected" : this.radioselected

 }
   this.router.navigate(['/admin/couponCodes/branches',{"name":user.name}]);
}

applyCoupon(){

  this.dataCompany.storage = {
    "companies": this.companies,
    "coupon": this.coupon,
  "branches": this.branches,
   "flag":this.companyFlag,
  "selected": this.user,
  "companiesSelected":this.companiesSelected,
  "radioselected" : this.radioselected

  }

     this.router.navigate(['/admin/couponCodes/createCoupon']);

}

}



// WEBPACK FOOTER //
// ./src/app/admin/layout/couponCode/targetaudcouponcode.component.ts